type TSort = Array<{ id: string; desc?: boolean }>;

interface IRankParams {
  sort: TSort;
  totalCount: number;
  page: number;
  pageSize: number;
}

/**
 * Determines whether the current sort column represents a statistical ranking.
 * Non-stat columns like "name" and "rank" don't have a meaningful ranking order.
 */
export function isStatisticalSort(sort: TSort): boolean {
  const sortColumn = sort.length > 0 ? sort[0].id : 'conversions';
  return sortColumn !== 'name' && sortColumn !== 'rank';
}

/**
 * Determines whether the current sort direction is descending.
 */
export function isSortDescending(sort: TSort): boolean {
  return sort.length > 0 && sort[0].desc === true;
}

/**
 * Computes the rank number for a row in the partner stats table.
 *
 * @param rawIndex - The zero-based row index within the current page.
 * @param params - Sort state, total count, and pagination info.
 * @returns The rank number, or null if ranking is not applicable
 *   (non-stat sort column or totalCount is 0).
 */
export function getRank(rawIndex: number, params: IRankParams): number | null {
  const { sort, totalCount, page, pageSize } = params;
  if (!isStatisticalSort(sort) || totalCount === 0) {
    return null;
  }
  const pageOffset = pageSize * page;
  if (isSortDescending(sort)) {
    return pageOffset + rawIndex + 1;
  }
  return totalCount - pageOffset - rawIndex;
}
